import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    exportFeatureList,
    exterirorColorCode,
    secondaryVehiclesTrims, setActiveLocale, setCompareDataGroupInfo,
    setCountry,
    setCTAbuttons, setCTARedirectURL, setModelTrim, setModelTrimVariation, setTrimModelName, setTrimModelYear
} from "../../slices/vehicleSlice";
import { useTranslation } from "react-i18next";
import PrintIcon from '@mui/icons-material/Print';
import {trackCTAButtons, trackPhotosPDF, trackPrintPDF} from "../GoogleTagManager.utils";
import BasicModal from "../Modal/BasicModal";

export const NavbarBtn = ({ compareTrim, singularButton }) => {

    const { t } = useTranslation();
    const ctaButtons = useSelector(setCTAbuttons);
    const exteriorColor = useSelector(exterirorColorCode)
    const trimCodes = useSelector(secondaryVehiclesTrims)
    const country = useSelector(setCountry)
    const ctaRedirects = useSelector(setCTARedirectURL);
    const host = window.location.host;
    let lang = useSelector(setActiveLocale)
    lang = lang && lang.substr(0, 2)
    const year = useSelector(setTrimModelYear)
    const model = useSelector(setTrimModelName)
    const trim = useSelector(setModelTrim);
    const variation = useSelector(setModelTrimVariation);
    const compareGroup = useSelector(setCompareDataGroupInfo)
    const {pathname} = window.location;
    const dispatch = useDispatch()
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [modalAction, setModalAction] = React.useState(null);
    const [ctaTextKey, setCtaTextKey] = React.useState(null);
    const [ctaID, setCtaID] = React.useState(null);
    const [handlerButton,isHandlerClicked] = React.useState(false);
    const [buttonURL,setHandlerURL] = React.useState(null);

    let buildPriceLink = ctaButtons?.find((button) => button.textKey === "cta.buildAndPrice")?.link;
    let requestQuoteLink = ctaButtons?.find((button) => button.textKey === "cta.requestQuote")?.link ;
    let findMyDealer = ctaButtons?.find((button) => button.textKey === "cta.findMyDealer")?.link;
    let dealerLocatorLink = ctaButtons?.find((button) => button.textKey === "cta.dealerLocator")?.link;

    let groupClasses = (singularButton === true) ? 'navbar-group singular-group' : 'navbar-group' ;

    useEffect(() => {
       if(ctaID !== null && handlerButton){
           trackCTAButtons(compareGroup, ctaID);
           isHandlerClicked(false)
           window.open(buttonURL.toString(), '_blank');
       }
    }, [ctaID,setCtaID, handlerButton,isHandlerClicked]);

    const handleBuildPriceClick = () => {
        setCtaTextKey(t('navigation.build'));
        setCtaID("Build & Price");
        if (buildPriceLink) {
            buildPriceLink = buildPriceLink.replace("@lang@", lang)
                .replace("@country@", country)
                .replace("@year@", year)
                .replace("@model@", model)
                .replace("@trim@", trim)
                .replace("@variation@", variation);
            if (ctaRedirects && ctaRedirects.brand.toLowerCase() === "mazda" && country.toLowerCase() !== "ca"){
                setModalAction("BuildPrice");
                setIsModalOpen(true);
                return;
            }
            isHandlerClicked(true)
            setHandlerURL(buildPriceLink)
        }
    };

    const handleRequestQuoteClick = () => {
        setCtaTextKey(t('navigation.quote'));
        setCtaID("Request A Quote");
        if (requestQuoteLink) {
            requestQuoteLink =  requestQuoteLink.replace("@lang@", lang)
                .replace("@country@", country)
                .replace("@year@", year)
                .replace("@model@", model)
                .replace("@trim@", trim)
                .replace("@variation@", variation);

            if (ctaRedirects && ctaRedirects.brand.toLowerCase() === "mazda" && country.toLowerCase() !== "ca") {
                setModalAction("RequestQuote");
                setIsModalOpen(true);
                return;
            }
            isHandlerClicked(true)
            setHandlerURL(requestQuoteLink)
        }
    };

    const handleFindMyDealerClick = () => {
        setCtaTextKey(t('navigation.dealer'));
        setCtaID("Find My Dealer");
        if (findMyDealer) {
            findMyDealer = findMyDealer.replace("@lang@", lang)
                .replace("@country@", country)
                .replace("@year@", year)
                .replace("@model@", model)
                .replace("@trim@", trim)
                .replace("@variation@", variation);
            isHandlerClicked(true)
            setHandlerURL(findMyDealer)
        }

    };

    const handlerDealerLocator = () => {
        setCtaTextKey(t('navigation.dealerLocator'));
        setCtaID("Dealer Locator");
        if (dealerLocatorLink) {
            dealerLocatorLink =  dealerLocatorLink.replace("@lang@", lang)
                .replace("@country@", country)
                .replace("@year@", year)
                .replace("@model@", model)
                .replace("@trim@", trim)
                .replace("@variation@", variation);
            isHandlerClicked(true)
            setHandlerURL(dealerLocatorLink)
        }
    }

    const handlePrintRequest = () => {
        const codes = []
        trimCodes.forEach((code) => {
            codes.push({
                code: code,
            });
        });

        const data = {
            exterior: exteriorColor,
            code: codes
        }
        pathname.includes('photos') ? trackPhotosPDF(compareGroup) :  trackPrintPDF(compareGroup)
        dispatch(exportFeatureList(data))
    }

    const handleContinueButtonClick = () => {
        if (modalAction === "BuildPrice") {
            isHandlerClicked(true)
            setHandlerURL(buildPriceLink)
        } else if (modalAction === "RequestQuote") {
            isHandlerClicked(true)
            setHandlerURL(requestQuoteLink)
        }
        setIsModalOpen(false);
    };

    return (
        <div className={groupClasses}>
            {compareTrim && (
                <button className={"primary-btn"} id={"nav-new-compare"} onClick={() => compareTrim()}>
                    {t('navigation.compare')}
                </button>
            )}
            {buildPriceLink && (
                <button className="primary-btn" id="cta-button" onClick={handleBuildPriceClick}>
                    {t('navigation.build')}
                </button>
            )}
            {requestQuoteLink && (
                <button className="primary-btn" id="cta-button" onClick={handleRequestQuoteClick}>
                    {t('navigation.quote')}
                </button>
            )}
            {findMyDealer && (
                <button className="primary-btn" id="cta-button" onClick={handleFindMyDealerClick}>
                    {t('navigation.dealer')}
                </button>)}
            {dealerLocatorLink && (
                <button className="primary-btn" id="cta-button" onClick={handlerDealerLocator}>
                    {t('navigation.dealerLocator')}
                </button>
            )}
            <button
                className={"primary-btn"}
                id={"nav-print-pdf"}
                onClick={handlePrintRequest}
                disabled={!trimCodes || trimCodes.length === 0}
                style={!trimCodes || trimCodes.length === 0 ? {
                    color: "#757575",
                    background: "#CCCCCC",
                    border: "1px solid #757575",
                    boxShadow: "none",
                    cursor: "not-allowed",
                    opacity: 1
                } : undefined}
            >
                <PrintIcon style={!trimCodes || trimCodes.length === 0 ? { color: "#757575" } : undefined} />
                {t('navigation.print')}
            </button>

            <BasicModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            >
                <div className={"description-modal redirect-modal"}>
                    <div className={"description-title"}>
                        <div className={"description-title-div"}>{t('ctaRedirect.title')} {host}</div>
                    </div>

                    <div>
                        {modalAction === "BuildPrice" && (
                            <div className={"description-body"}>{t('ctaRedirect.content')} </div>
                        )}
                        {modalAction === "RequestQuote" && (
                            <div className={"description-body"}>{t('ctaRedirect.content')} </div>
                        )}
                    </div>
                   <div className={"redirect-modal-footer"}>
                       <div className={"redirect-buttons"}>
                           <button className={"btn-default"} onClick={handleContinueButtonClick}>{t('continue')}</button>
                           <button className={"btn-default"} onClick={() => setIsModalOpen(false)}>{t('cancel')}</button>
                       </div>
                   </div>
                </div>
            </BasicModal>
        </div>
    );
}
